import { createContext } from 'react';
export var currentRenderDirectionContext = createContext('vertical');
